import React from 'react';
import { Box } from '@rebass/grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';
import { useIsMobile } from '../../lib/hooks/use-is-mobile';
import { colors } from '../../config/theme';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.textPrimary};
  height: 60px;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 0 8px 0 16px;
  box-sizing: border-box;
  background: ${colors.surface};
`;

const Content = styled.div`
  padding: 8px 16px 24px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const SideSheet = ({ open, onClose, title, children }) => {
  const { isMobile } = useIsMobile();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          background: colors.surface,
          height: '100vh',
          width: isMobile ? '100%' : '480px',
          overflowX: 'hidden',
          overflowY: 'auto',
        },
      }}
      transitionDuration={{ enter: 350, exit: 300 }} // Adjust the animation duration (in milliseconds)
      BackdropProps={{ invisible: isMobile ? true : false }}
    >
      <Header>
        <Typography variant="subtitle1">{title}</Typography>
        <IconButton onClick={onClose} size="small">
          <Close style={{ color: colors.textPrimary }} />
        </IconButton>
      </Header>
      <Content>
        <Box>{children}</Box>
      </Content>
    </Drawer>
  );
};

export default SideSheet;
